import React from 'react'
import Navbar from './Navbar'
import './css/client.css'
import Footer from './Footer'
import Section1 from './Section1'
import ClientItem from './ClientItem'
// import image1 from "../components/assets/img/bg/sectionbg.png";
import IMAGES from '../components/assets/img/ImageClient.js'
export default function Client() {
    return (
        <>
            <Navbar />
            <main className="main">
                <Section1 sectionName={"Client"} />
                <section className="section2">
                    <div className="section_container">
                        <div class="client_container">
                            <ul>
                                <ClientItem clientImage={IMAGES.client1}/>
                                <ClientItem clientImage={IMAGES.client2}/>
                                <ClientItem clientImage={IMAGES.client3}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client5}/>
                                <ClientItem clientImage={IMAGES.client6}/>
                                <ClientItem clientImage={IMAGES.client7}/>
                                <ClientItem clientImage={IMAGES.client8}/>
                                <ClientItem clientImage={IMAGES.client9}/>
                                <ClientItem clientImage={IMAGES.client10}/>
                                <ClientItem clientImage={IMAGES.client11}/>
                                <ClientItem clientImage={IMAGES.client12}/>
                                <ClientItem clientImage={IMAGES.client13}/>
                                <ClientItem clientImage={IMAGES.client14}/>
                                <ClientItem clientImage={IMAGES.client15}/>
                                <ClientItem clientImage={IMAGES.client16}/>
                                <ClientItem clientImage={IMAGES.client17}/>
                                <ClientItem clientImage={IMAGES.client18}/>
                                <ClientItem clientImage={IMAGES.client19}/>
                                <ClientItem clientImage={IMAGES.client20}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                                <ClientItem clientImage={IMAGES.client4}/>
                            </ul>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}
